<template>
  <div class="crm-main-cont">
    <a-tabs @change="callback" default-active-key="1">
      <a-tab-pane tab="待受理" :key="1">
        <div class="search-box">
          <a-form :form="formSearch1" layout="inline">
            <a-form-item  label="主体名称:">
              <a-input v-decorator="['companyName', ]"/>
            </a-form-item>
            <a-form-item label="产品名称:">
              <a-input v-decorator="['productName', ]"/>
            </a-form-item>
          </a-form>
        </div>
        <div class="btns-group">
          <a-button @click="searchConfirm1" type="primary" style="margin-top: 26px;">搜索</a-button>
          <a-button @click="backConfirm1">重置</a-button>
        </div>
        <a-table
            bordered
            rowKey="id"
            :dataSource="dataSource1"
            :pagination="pagination"
            :columns="columns"
            @change="tableChange1"
        >
          <template slot="operation" slot-scope="text, record">
            <a @click="show(record)">查看详情&nbsp;&nbsp;&nbsp;</a>
            <a @click="showUpdate(record)">受理</a>
          </template>
        </a-table>
      </a-tab-pane>
      <a-tab-pane tab="已受理" :key="2">
        <div class="search-box">
          <a-form :form="formSearch2" layout="inline">
            <a-form-item  label="主体名称:">
              <a-input v-decorator="['companyName', ]"/>
            </a-form-item>
            <a-form-item label="产品名称:">
              <a-input v-decorator="['productName', ]"/>
            </a-form-item>
          </a-form>
        </div>
        <div class="btns-group">
          <a-button @click="searchConfirm2" type="primary" style="margin-top: 26px;">搜索</a-button>
          <a-button @click="backConfirm2">重置</a-button>
        </div>
        <a-table
            bordered
            rowKey="id"
            :dataSource="dataSource2"
            :pagination="pagination"
            :columns="columns"
            @change="tableChange2"
        >
          <template slot="operation" slot-scope="text, record">
            <a @click="show(record)">查看详情&nbsp;&nbsp;&nbsp;</a>
            <a @click="showYes(record)">授信&nbsp;&nbsp;&nbsp;</a>
            <a @click="showNo(record)">拒贷</a>
          </template>
        </a-table>
      </a-tab-pane>
      <a-tab-pane tab="已授信" :key="3">
        <div class="search-box">
          <a-form :form="formSearch3" layout="inline">
            <a-form-item  label="主体名称:">
              <a-input v-decorator="['companyName', ]"/>
            </a-form-item>
            <a-form-item label="产品名称:">
              <a-input v-decorator="['productName', ]"/>
            </a-form-item>
          </a-form>
        </div>
        <div class="btns-group">
          <a-button @click="searchConfirm3" type="primary" style="margin-top: 26px;">搜索</a-button>
          <a-button @click="backConfirm3">重置</a-button>
        </div>
        <a-table
            bordered
            rowKey="id"
            :dataSource="dataSource3"
            :pagination="pagination"
            :columns="columns"
            @change="tableChange3"
        >
          <template slot="operation" slot-scope="text, record">
            <a @click="show(record)">查看详情&nbsp;&nbsp;&nbsp;</a>
          </template>
        </a-table>
      </a-tab-pane>
      <a-tab-pane tab="已拒贷" :key="4">
        <div class="search-box">
          <a-form :form="formSearch4" layout="inline">
            <a-form-item  label="主体名称:">
              <a-input v-decorator="['companyName', ]"/>
            </a-form-item>
            <a-form-item label="产品名称:">
              <a-input v-decorator="['productName', ]"/>
            </a-form-item>
          </a-form>
        </div>
        <div class="btns-group">
          <a-button @click="searchConfirm4" type="primary" style="margin-top: 26px;">搜索</a-button>
          <a-button @click="backConfirm4">重置</a-button>
        </div>
        <a-table
            bordered
            rowKey="id"
            :dataSource="dataSource4"
            :pagination="pagination"
            :columns="columns"
            @change="tableChange4"
        >
          <template slot="operation" slot-scope="text, record">
            <a @click="show(record)">查看详情&nbsp;&nbsp;&nbsp;</a>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>

    <a-drawer
        title="转贷申请详情"
        width="800"
        @close="onClose"
        :visible="visible"
    >
      <div>
        <a-descriptions :column="4" bordered="true">
          <a-descriptions-item label="主体名称" :span="2">
            {{ zdcpOrder.companyName }}
          </a-descriptions-item>
          <a-descriptions-item label="社会统一信用代码" :span="2">
            {{ zdcpOrder.uscc }}
          </a-descriptions-item>
          <a-descriptions-item label="法人代表" :span="2">
            {{ zdcpOrder.master }}
          </a-descriptions-item>
          <a-descriptions-item label="联系人" :span="2">
            {{ zdcpOrder.contact }}
          </a-descriptions-item>
          <a-descriptions-item label="电话号码" :span="1">
            {{ zdcpOrder.tel }}
          </a-descriptions-item>
          <a-descriptions-item label="经营地址" :span="3">
            {{ zdcpOrder.address }}
          </a-descriptions-item>
          <a-descriptions-item label="申请产品" :span="2">
            {{ zdcpOrder.productName }}
          </a-descriptions-item>
          <a-descriptions-item label="申请时间" :span="2">
            {{ zdcpOrder.createTime }}
          </a-descriptions-item>
          <a-descriptions-item label="所属金融机构" :span="4">
            {{ zdcpOrder.financeName }}
          </a-descriptions-item>
          <a-descriptions-item label="原贷款银行" :span="4">
            {{ zdcpOrder.bank }}
          </a-descriptions-item>
          <a-descriptions-item label="原贷款金额(万元)" :span="2">
            {{ zdcpOrder.oldAmount }}
          </a-descriptions-item>
          <a-descriptions-item label="续贷金额(万元)" :span="2">
            {{ zdcpOrder.oldAmountContinue }}
          </a-descriptions-item>
          <a-descriptions-item label="原贷款到期时间" :span="2">
            {{ zdcpOrder.endTime }}
          </a-descriptions-item>
          <a-descriptions-item label="原贷款保证人或抵押物品" :span="2">
            {{ zdcpOrder.ensurePeople }}
          </a-descriptions-item>
          <a-descriptions-item label="贷款账户户名" :span="1">
            {{ zdcpOrder.loanName }}
          </a-descriptions-item>
            <a-descriptions-item label="贷款账号" :span="2">
              {{ zdcpOrder.loanNum }}
            </a-descriptions-item>
            <a-descriptions-item label="申请金额(万元)" :span="1">
              {{ zdcpOrder.status }}
            </a-descriptions-item>
            <a-descriptions-item label="贷款期限起" :span="2">
              {{ zdcpOrder.startDate}}
            </a-descriptions-item>
            <a-descriptions-item label="贷款期限止" :span="2">
              {{ zdcpOrder.startDate}}
            </a-descriptions-item>
            <a-descriptions-item label="附件文件下载" :span="3">
              <a-button size="small"
                        :href="'/xydapi/zdcp/download?fileName='+yyzz"
              >
                营业执照
              </a-button>
              <a-button size="small"
                        :href="'/xydapi/zdcp/download?fileName='+zxbg"
                        style="margin-left: 10px;"
              >
                征信报告
              </a-button>
              <a-button size="small"
                        :href="'/xydapi/zdcp/download?fileName='+jkht"
                        style="margin-left: 10px;"
              >
                查看文件
              </a-button>
              <a-button size="small"
                        :href="'/xydapi/zdcp/download?fileName='+gsjj"
                        style="margin-left: 10px;"
              >
                公司简介
              </a-button>
            </a-descriptions-item>
        </a-descriptions>
      </div>
    </a-drawer>

    <a-modal
        title="转贷订单受理"
        width="450px"
        :closable="false"
        :visible="visible2"
    >
      <b><big>请确认是否受理!</big></b>
      <template slot="footer">
        <a-button @click="updateStatus"> 确认 </a-button>
        <a-button @click="onClose2"> 取消 </a-button>
      </template>
    </a-modal>
    <a-modal
        title="拒贷原因"
        width="450px"
        :closable="false"
        :visible="visible3"
    >
      <p>请在下方填写拒贷原因！</p>
      <a-textarea
          style="margin-top: 5px"
          v-model="updateStatusReq.reason"
          :auto-size="{ minRows: 3, maxRows: 5 }"
      />
      <template slot="footer">
        <a-button @click="updateStatus"> 确认 </a-button>
        <a-button @click="onClose3"> 取消 </a-button>
      </template>
    </a-modal>
    <a-modal
        title="关联银行"
        width="450px"
        :closable="false"
        :visible="visible4"
    >
      <p>请在下方选择关联银行！</p>
        <a-form :form="form">
          <a-form-item>
            <a-select mode="default" v-decorator="['bankId',
                                        {
                                            rules: [
                                                {
                                                    required: true,
                                                    message: '请选择关联银行！'
                                                }
                                            ]
                                        }]"
                      placeholder="请选择关联银行"
            >
              <a-select-option v-for="item in bank" :key="item.id">
                {{ item.full_name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      <template slot="footer">
        <a-button @click="updateStatus"> 确认 </a-button>
        <a-button @click="onClose4"> 取消 </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import {getByOrderStatus, updateOrderStatus, findAllYxdwgl} from "@/api/zdcp/zdcp";
const columns = [
  {
    title: "主体名称",
    dataIndex: "companyName",
    key: "companyName",
    width: 200,
    align: "center"
  },
  {
    title: "社会统一信用代码",
    dataIndex: "uscc",
    key: "uscc",
    width: 180,
    align: "center"
  },
  {
    title: "申请产品",
    dataIndex: "productName",
    key: "productName",
    width: 200,
    align: "center"
  },
  {
    title: "申请金额(万元)",
    dataIndex: "amount",
    key: "amount",
    align: "center",
    width: 140,
  },
  {
    title: "申请日期",
    dataIndex: "createTime",
    key: "createTime",
    width: 140,
    align: "center"
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: {customRender: "operation"},
    align: "center",
    width: 200
  }
];
export default {

  data() {

    return {
      form: this.$form.createForm(this),
      formSearch1: this.$form.createForm(this),
      formSearch2: this.$form.createForm(this),
      formSearch3: this.$form.createForm(this),
      formSearch4: this.$form.createForm(this),
      columns,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      dataSource1: [],
      dataSource2: [],
      dataSource3: [],
      dataSource4: [],
      reqBody: {
        productName: "",
        companyName: "",
        pageNum: 1,
      },
      companyName: "",
      productName: "",
      visible: false,
      visible2: false,
      visible3: false,
      visible4: false,
      zdcpOrder: "",
      updateStatusReq: {
        status: "",
        id: "",
        reason: "",
        bankId: "",
      },
      bank: [],
      yyzz: "",
      zxbg: "",
      jkht: "",
      gsjj: "",
    }
  },

  //列表显示
  beforeRouteEnter(to, from, next) {
    getByOrderStatus("", "",  1, 0)
        .then(res => {
          next(vm => {
            if (res.data.success === "TRUE") {
              vm.dataSource1 = res.data.data.result.list;
              let This = vm;
              for (let i=0; i<This.dataSource1.length; i++) {
                This.dataSource1[i].createTime = This.format2(This.dataSource1[i].createTime);
                This.dataSource1[i].endTime = This.format2(This.dataSource1[i].endTime);
                This.dataSource1[i].startDate = This.format2(This.dataSource1[i].startDate);
                This.dataSource1[i].endDate = This.format2(This.dataSource1[i].endDate);
              }
              vm.pagination = {
                current: res.data.data.result.pageNum,
                pageSize: res.data.data.result.pageSize,
                total: res.data.data.result.total
              };
            }
          });
        })
        .catch(() => {
          next(vm => {
            vm.$message.error("服务器出错！请稍后再试!");
            vm.$Progress.fail();
          });
        });

    getByOrderStatus("", "",  1, 1)
        .then(res => {
          next(vm => {
            if (res.data.success === "TRUE") {
              vm.dataSource2 = res.data.data.result.list;
              let This = vm;
              for (let i=0; i<This.dataSource2.length; i++) {
                This.dataSource2[i].createTime = This.format2(This.dataSource2[i].createTime);
                This.dataSource2[i].endTime = This.format2(This.dataSource2[i].endTime);
                This.dataSource2[i].startDate = This.format2(This.dataSource2[i].startDate);
                This.dataSource2[i].endDate = This.format2(This.dataSource2[i].endDate);
              }
              vm.pagination = {
                current: res.data.data.result.pageNum,
                pageSize: res.data.data.result.pageSize,
                total: res.data.data.result.total
              };
            }
          });
        })
        .catch(() => {
          next(vm => {
            vm.$message.error("服务器出错！请稍后再试!");
            vm.$Progress.fail();
          });
        });

    getByOrderStatus("", "",  1, 2)
        .then(res => {
          next(vm => {
            if (res.data.success === "TRUE") {
              vm.dataSource3 = res.data.data.result.list;
              let This = vm;
              for (let i=0; i<This.dataSource3.length; i++) {
                This.dataSource3[i].createTime = This.format2(This.dataSource3[i].createTime);
                This.dataSource3[i].endTime = This.format2(This.dataSource3[i].endTime);
                This.dataSource3[i].startDate = This.format2(This.dataSource3[i].startDate);
                This.dataSource3[i].endDate = This.format2(This.dataSource3[i].endDate);
              }
              vm.pagination = {
                current: res.data.data.result.pageNum,
                pageSize: res.data.data.result.pageSize,
                total: res.data.data.result.total
              };
            }
          });
        })
        .catch(() => {
          next(vm => {
            vm.$message.error("服务器出错！请稍后再试!");
            vm.$Progress.fail();
          });
        });

    getByOrderStatus("", "",  1, 3)
        .then(res => {
          next(vm => {
            if (res.data.success === "TRUE") {
              vm.dataSource4 = res.data.data.result.list;
              let This = vm;
              for (let i=0; i<This.dataSource4.length; i++) {
                This.dataSource4[i].createTime = This.format2(This.dataSource4[i].createTime);
                This.dataSource4[i].endTime = This.format2(This.dataSource4[i].endTime);
                This.dataSource4[i].startDate = This.format2(This.dataSource4[i].startDate);
                This.dataSource4[i].endDate = This.format2(This.dataSource4[i].endDate);
              }
              vm.pagination = {
                current: res.data.data.result.pageNum,
                pageSize: res.data.data.result.pageSize,
                total: res.data.data.result.total
              };
            }
          });
        })
        .catch(() => {
          next(vm => {
            vm.$message.error("服务器出错！请稍后再试!");
            vm.$Progress.fail();
          });
        });
  },

  methods: {
    showYes(record) {
      this.form.resetFields();
      this.updateStatusReq.id = record.id;
      this.updateStatusReq.status = 2;
      this.visible4 = true;
    },
    onClose4() {
      this.visible4 = false;
      this.updateStatusReq.id = "";
      this.updateStatusReq.status = "";
      this.updateStatusReq.reason = "";
      this.updateStatusReq.bankId = "";
    },
    showNo(record) {
      this.updateStatusReq.id = record.id;
      this.updateStatusReq.status = 3;
      this.visible3 = true;
    },
    onClose3() {
      this.visible3 = false;
      this.updateStatusReq.id = "";
      this.updateStatusReq.status = "";
      this.updateStatusReq.reason = "";
    },
    updateStatus() {
      if (this.updateStatusReq.status === 3 && this.updateStatusReq.reason == "") {
        this.$message.warning("请输入拒贷原因");
        return;
      }
      this.form.validateFields((err, values) => {
        if(!err) {
          this.updateStatusReq.bankId = values.bankId;
        }
      })
      if (this.updateStatusReq.status === 2 && this.updateStatusReq.bankId == "") {
        return;
      }
      updateOrderStatus(this.updateStatusReq)
          .then(res => {
            if (res.data.success === "TRUE") {
              if (this.updateStatusReq.status === 3) {
                this.$message.success("已拒贷！");
              } else if(this.updateStatusReq.status === 2){
                this.$message.success("已授信！");
              } else {
                this.$message.success("已受理！");
              }
              this.initList1();
              this.onClose2();
              this.initList2();
              this.onClose3();
              this.onClose4();
            }
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    showUpdate(record) {
      this.updateStatusReq.id = record.id;
      this.updateStatusReq.status = 1;
      this.visible2 = true;
    },
    onClose2() {
      this.visible2 = false;
      this.updateStatusReq.id = "";
      this.updateStatusReq.status = "";
    },
    onClose() {
      this.visible = false;
      this.zdcpOrder = "";
      this.yyzz = "";
      this.zxbg = "";
      this.jkht = "";
      this.gsjj = "";
    },
    show(record) {
      this.visible = true;
      this.zdcpOrder = record;
      this.yyzz = record.yyzz;
      this.zxbg = record.zxbg;
      this.jkht = record.jkht;
      this.gsjj = record.gsjj;
    },
    format2(shijianchuo) {
      // 时间戳转日期
      //shijianchuo是整数，否则要parseInt转换
      if (!shijianchuo) return;
      if (shijianchuo.length == 10) {
        shijianchuo = parseInt(shijianchuo) * 1000;
      } else {
        shijianchuo = parseInt(shijianchuo);
      }
      var time = new Date(shijianchuo);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      return y + "-" + this.add0(m) + "-" + this.add0(d);
    },

    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    tableChange1(page) {
      this.pagination.current = page.current;
      this.initList1();
    },
    tableChange2(page) {
      this.pagination.current = page.current;
      this.initList2();
    },
    tableChange3(page) {
      this.pagination.current = page.current;
      this.initList3();
    },
    tableChange4(page) {
      this.pagination.current = page.current;
      this.initList4();
    },
    backConfirm1() {
      this.formSearch1.resetFields();
      this.pagination.current = 1;
      this.productName = "";
      this.companyName = "";
      this.initList1();
    },
    searchConfirm1() {
      this.formSearch1.validateFields((err, values) => {
        if (values.productName != null || values.companyName != null) {
          this.productName = values.productName;
          this.companyName = values.companyName;
        }else {
          this.productName = "";
          this.companyName = "";
        }
        this.pagination.current = 1;
        this.initList1();
      })
    },
    backConfirm2() {
      this.formSearch2.resetFields();
      this.pagination.current = 1;
      this.productName = "";
      this.companyName = "";
      this.initList2();
    },
    searchConfirm2() {
      this.formSearch2.validateFields((err, values) => {
        if (values.productName != null || values.companyName != null) {
          this.productName = values.productName;
          this.companyName = values.companyName;
        }else {
          this.productName = "";
          this.companyName = "";
        }
        this.pagination.current = 1;
        this.initList2();
      })
    },
    backConfirm3() {
      this.formSearch3.resetFields();
      this.pagination.current = 1;
      this.productName = "";
      this.companyName = "";
      this.initList3();
    },
    searchConfirm3() {
      this.formSearch3.validateFields((err, values) => {
        if (values.productName != null || values.companyName != null) {
          this.productName = values.productName;
          this.companyName = values.companyName;
        }else {
          this.productName = "";
          this.companyName = "";
        }
        this.pagination.current = 1;
        this.initList3();
      })
    },
    backConfirm4() {
      this.formSearch4.resetFields();
      this.pagination.current = 1;
      this.productName = "";
      this.companyName = "";
      this.initList4();
    },
    searchConfirm4() {
      this.formSearch4.validateFields((err, values) => {
        if (values.productName != null || values.companyName != null) {
          this.productName = values.productName;
          this.companyName = values.companyName;
        }else {
          this.productName = "";
          this.companyName = "";
        }
        this.pagination.current = 1;
        this.initList4();
      })
    },
    initList1() {
      this.reqBody.pageNum = this.pagination.current;
      this.reqBody.productName = this.productName;
      this.reqBody.companyName = this.companyName;
      getByOrderStatus(this.reqBody.productName,this.reqBody.companyName,this.reqBody.pageNum,0)
          .then(res => {
              if (res.data.success === "TRUE") {
                this.dataSource1 = res.data.data.result.list;
                for (let i=0; i<this.dataSource1.length; i++) {
                  this.dataSource1[i].createTime = this.format2(this.dataSource1[i].createTime);
                  this.dataSource1[i].startDate = this.format2(this.dataSource1[i].startDate);
                  this.dataSource1[i].endDate = this.format2(this.dataSource1[i].endDate);
                  this.dataSource1[i].endTime = this.format2(this.dataSource1[i].endTime);
                }
                this.pagination = {
                  current: res.data.data.result.pageNum,
                  pageSize: res.data.data.result.pageSize,
                  total: res.data.data.result.total
                };
              }
          })
          .catch(() => {
              this.$message.error("服务器出错！请稍后再试!");
          });
    },
    initList2() {
      this.reqBody.pageNum = this.pagination.current;
      this.reqBody.productName = this.productName;
      this.reqBody.companyName = this.companyName;
      getByOrderStatus(this.reqBody.productName,this.reqBody.companyName,this.reqBody.pageNum,1)
          .then(res => {
            if (res.data.success === "TRUE") {
              this.dataSource2 = res.data.data.result.list;
              for (let i=0; i<this.dataSource2.length; i++) {
                this.dataSource2[i].createTime = this.format2(this.dataSource2[i].createTime);
                this.dataSource2[i].startDate = this.format2(this.dataSource2[i].startDate);
                this.dataSource2[i].endDate = this.format2(this.dataSource2[i].endDate);
                this.dataSource2[i].endTime = this.format2(this.dataSource2[i].endTime);
              }
              this.pagination = {
                current: res.data.data.result.pageNum,
                pageSize: res.data.data.result.pageSize,
                total: res.data.data.result.total
              };
            }
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
      findAllYxdwgl()
          .then((res) => {
            if (res.data.success === "TRUE") {
              this.bank = res.data.data.result;
            }
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    initList3() {
      this.reqBody.pageNum = this.pagination.current;
      this.reqBody.productName = this.productName;
      this.reqBody.companyName = this.companyName;
      getByOrderStatus(this.reqBody.productName,this.reqBody.companyName,this.reqBody.pageNum,2)
          .then(res => {
            if (res.data.success === "TRUE") {
              this.dataSource3 = res.data.data.result.list;
              for (let i=0; i<this.dataSource3.length; i++) {
                this.dataSource3[i].createTime = this.format2(this.dataSource3[i].createTime);
                this.dataSource3[i].startDate = this.format2(this.dataSource3[i].startDate);
                this.dataSource3[i].endDate = this.format2(this.dataSource3[i].endDate);
                this.dataSource3[i].endTime = this.format2(this.dataSource3[i].endTime);
              }
              this.pagination = {
                current: res.data.data.result.pageNum,
                pageSize: res.data.data.result.pageSize,
                total: res.data.data.result.total
              };
            }
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    initList4() {
      this.reqBody.pageNum = this.pagination.current;
      this.reqBody.productName = this.productName;
      this.reqBody.companyName = this.companyName;
      getByOrderStatus(this.reqBody.productName,this.reqBody.companyName,this.reqBody.pageNum,3)
          .then(res => {
            if (res.data.success === "TRUE") {
              this.dataSource4 = res.data.data.result.list;
              for (let i=0; i<this.dataSource4.length; i++) {
                this.dataSource4[i].createTime = this.format2(this.dataSource4[i].createTime);
                this.dataSource4[i].startDate = this.format2(this.dataSource4[i].startDate);
                this.dataSource4[i].endDate = this.format2(this.dataSource4[i].endDate);
                this.dataSource4[i].endTime = this.format2(this.dataSource4[i].endTime);
              }
              this.pagination = {
                current: res.data.data.result.pageNum,
                pageSize: res.data.data.result.pageSize,
                total: res.data.data.result.total
              };
            }
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    callback(key) {
      if (key == 1) {
        this.initList1();
      } else if (key == 2) {
        this.initList2();
      }else if (key == 3) {
        this.initList3();
      }else if (key == 4) {
        this.initList4();
      }
    },
  }

}
</script>

<style scoped lang="less">
.search-box {
  .ant-form-item {
    display: inline-block;
    min-width: 280px;
  }

  .ant-select {
    width: 169px;
  }
}

.btns-group button {
  margin-right: 10px;
  margin-top: 24px;
  margin-bottom: 20px;
}

/deep/ .ant-descriptions-item-label {
  width: 20%;
}
</style>